module.exports = __webpack_public_path__ + "media/images/flags/1x1/grl-bbb839990163e5cf1ff01530e383e709.svg";